// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-page {
  background: var(--bg-primary);
}

.product-container {
  max-width: var(--page-max);
  margin: 0 auto;
  padding: 1.5rem 1.5rem 4rem;
}

/* Hero */
.product-hero {
  display: grid;
  grid-template-columns: minmax(0, 26rem) minmax(0, 1fr);
  gap: 2.5rem;
  align-items: center;
  margin: 1.25rem 0 2.25rem;
}

/* Produktbild im Rahmen mit Eckmarken (zeichnet sich beim Laden einmal nach) */
.product-dial {
  display: grid;
  place-items: center;
  aspect-ratio: 1;
  max-width: 100%;
  overflow: hidden;
  --frame-tick: 22px;
}

.product-dial img {
  position: relative;
  display: block;
  width: 96%;
  height: auto;
}

.product-hero-info {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.9rem;
  min-width: 0;
}

.product-hero-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6rem;
}

.product-title {
  margin: 0;
  font-size: clamp(2.6rem, 8vw, 4.5rem);
  font-weight: 700;
  line-height: 0.95;
  text-transform: uppercase;
  letter-spacing: 0.005em;
}

.product-tagline {
  margin: 0;
  max-width: 40rem;
  font-size: 1.12rem;
  color: var(--text-secondary);
}

.product-specs {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  margin: 0.25rem 0 0;
  border-top: 1px solid var(--border-primary);
  border-bottom: 1px solid var(--border-primary);
}

.product-specs > div {
  display: grid;
  gap: 0.1rem;
  padding: 0.6rem 1.4rem 0.6rem 0;
  margin-right: 1.4rem;
  border-right: 1px solid var(--border-primary);
}

.product-specs > div:last-child {
  border-right: 0;
  margin-right: 0;
}

.product-specs dt {
  font-family: var(--font-mono);
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: var(--text-tertiary);
}

.product-specs dd {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 1.05rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.product-compat {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-weight: 700;
}

.product-compat.ok {
  color: var(--success);
}

.product-compat.no {
  color: var(--signal);
}

.product-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 0.25rem;
}

.russia-payment-warning {
  margin: 0;
  padding: 0.75rem 1rem;
  border: 1px solid var(--warning);
  color: var(--text-primary);
  font-size: 0.92rem;
}

@media (max-width: 820px) {
  .product-hero {
    grid-template-columns: minmax(0, 1fr);
    gap: 1.5rem;
  }

  .product-dial {
    width: min(100%, 20rem);
    justify-self: center;
  }
}

@media (max-width: 680px) {
  .product-container {
    padding: 1rem 1rem 3rem;
  }

  .product-specs > div {
    padding-right: 1rem;
    margin-right: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/WatchfaceDetailPage/WatchfaceDetailPage.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sDAAsD;EACtD,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,mBAAmB;EACnB,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,+BAA+B;EAC/B,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".product-page {\n  background: var(--bg-primary);\n}\n\n.product-container {\n  max-width: var(--page-max);\n  margin: 0 auto;\n  padding: 1.5rem 1.5rem 4rem;\n}\n\n/* Hero */\n.product-hero {\n  display: grid;\n  grid-template-columns: minmax(0, 26rem) minmax(0, 1fr);\n  gap: 2.5rem;\n  align-items: center;\n  margin: 1.25rem 0 2.25rem;\n}\n\n/* Produktbild im Rahmen mit Eckmarken (zeichnet sich beim Laden einmal nach) */\n.product-dial {\n  display: grid;\n  place-items: center;\n  aspect-ratio: 1;\n  max-width: 100%;\n  overflow: hidden;\n  --frame-tick: 22px;\n}\n\n.product-dial img {\n  position: relative;\n  display: block;\n  width: 96%;\n  height: auto;\n}\n\n.product-hero-info {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.9rem;\n  min-width: 0;\n}\n\n.product-hero-tags {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.product-title {\n  margin: 0;\n  font-size: clamp(2.6rem, 8vw, 4.5rem);\n  font-weight: 700;\n  line-height: 0.95;\n  text-transform: uppercase;\n  letter-spacing: 0.005em;\n}\n\n.product-tagline {\n  margin: 0;\n  max-width: 40rem;\n  font-size: 1.12rem;\n  color: var(--text-secondary);\n}\n\n.product-specs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  margin: 0.25rem 0 0;\n  border-top: 1px solid var(--border-primary);\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.product-specs > div {\n  display: grid;\n  gap: 0.1rem;\n  padding: 0.6rem 1.4rem 0.6rem 0;\n  margin-right: 1.4rem;\n  border-right: 1px solid var(--border-primary);\n}\n\n.product-specs > div:last-child {\n  border-right: 0;\n  margin-right: 0;\n}\n\n.product-specs dt {\n  font-family: var(--font-mono);\n  font-size: 0.66rem;\n  font-weight: 600;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: var(--text-tertiary);\n}\n\n.product-specs dd {\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 1.05rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.product-compat {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n  font-weight: 700;\n}\n\n.product-compat.ok {\n  color: var(--success);\n}\n\n.product-compat.no {\n  color: var(--signal);\n}\n\n.product-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  margin-top: 0.25rem;\n}\n\n.russia-payment-warning {\n  margin: 0;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--warning);\n  color: var(--text-primary);\n  font-size: 0.92rem;\n}\n\n@media (max-width: 820px) {\n  .product-hero {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 1.5rem;\n  }\n\n  .product-dial {\n    width: min(100%, 20rem);\n    justify-self: center;\n  }\n}\n\n@media (max-width: 680px) {\n  .product-container {\n    padding: 1rem 1rem 3rem;\n  }\n\n  .product-specs > div {\n    padding-right: 1rem;\n    margin-right: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
